<template>
  <div>
    <div class="popup-backdrop"></div>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="confirm-message">
            Are you sure you want to end the test?
          </div>
          <div style="display: flex;flex-direction: column">
            <div class="time-left">
              <span class="span-message">You have</span>
              <div class="time-left-box">
                <img src="../assets/timer_red.svg" />
                <div class="duration-left">{{ getDurationLeft }}</div>
                <div>mins left</div>
              </div>
            </div>
            <div class="hr"></div>
            <div class="time-left">
              <span class="span-message">Counted for Evaluation</span>
              <div class="time-left-box">
                <img src="../assets/question.svg" alt="Q" />
                <div class="duration-left">{{ this.numbers['answered'] }}</div>
                <div>"Answered"</div>
              </div>
              <div class="time-left-box">
                <img src="../assets/question.svg" alt="Q" />
                <div class="duration-left">
                  {{ this.numbers['mark_review_answered'] }}
                </div>
                <div>"Answered" and Marked For Review</div>
              </div>
            </div>
          </div>
          <div class="hr"></div>
          <div class="time-left">
            <span class="span-message">Not counted for Evaluation</span>
            <div class="time-left-box">
              <img src="../assets/question.svg" alt="Q" />
              <div class="duration-left">{{ this.numbers['un_answered'] }}</div>
              <div>"Unanswered"</div>
            </div>
            <div class="time-left-box">
              <img src="../assets/question.svg" alt="Q" />
              <div class="duration-left">
                {{ this.numbers['mark_review_unanswered'] }}
              </div>
              <div>"Unanswered" and Marked For Review</div>
            </div>
          </div>
          <div class="hr-footer"></div>
          <div class="buttons">
            <div id="endtest-button">
              <div class="end-test-text" @click="EndTest">
                <span style="margin: auto 0 auto 8px; min-width: 64px"
                  >END TEST</span
                >
                <img
                  alt="close"
                  style="margin-left:10px;"
                  src="../assets/Cross_Symbol.svg"
                />
              </div>
            </div>
            <div class="cancel">
              <button class="cancel-button" @click="$emit('close')">
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  name: 'EndTest',
  props: ['mcqs', 'prog', 'sub'],
  computed: {
    ...mapState({
      durationLeft: state => state.test.durationLeft,
    }),
    ...mapGetters(['getDurationLeft']),
  },
  methods: {
    ...mapActions(['endTest']),
    EndTest() {
      this.$store.state.showPopup = false
      this.endTest(this.$router)
    },
  },
  created() {
    var question
    for (question of this.mcqs.questions) {
      if (question.currentClass === 'normal') {
        this.numbers.un_answered += 1
      } else if (question.currentClass === 'reviewSubmit') {
        this.numbers.mark_review_answered += 1
      } else if (question.currentClass === 'review') {
        this.numbers.mark_review_unanswered += 1
      }
    }
    this.numbers.answered += this.mcqs.totalSaved
    for (question of this.prog.questions) {
      if (question.currentClass === 'normal') {
        this.numbers.un_answered += 1
      } else if (question.currentClass === 'reviewSubmit') {
        this.numbers.mark_review_answered += 1
      } else if (question.currentClass === 'review') {
        this.numbers.mark_review_unanswered += 1
      }
    }
    this.numbers.answered += this.prog.totalSaved
    for (question of this.sub.questions) {
      if (question.currentClass === 'normal') {
        this.numbers.un_answered += 1
      } else if (question.currentClass === 'reviewSubmit') {
        this.numbers.mark_review_answered += 1
      } else if (question.currentClass === 'review') {
        this.numbers.mark_review_unanswered += 1
      }
    }
    this.numbers.answered +=
      this.sub.totalSaved - this.numbers.mark_review_answered
  },
  data: function() {
    return {
      numbers: {
        un_answered: 0,
        mark_review_unanswered: 0,
        mark_review_answered: 0,
        answered: 0,
      },
      messages: [
        'Unattempted',
        '"Answered" and Marked For Review',
        '"Unanswered" and Marked For Review',
        '"Answered"',
      ],
    }
  },
}
</script>

<style scoped>
.popup-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  background-color: #000;
  opacity: 0.4;
  filter: alpha(opacity=50);
}
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
  transition: opacity 0.3s ease;
  z-index: 2;
}
.cancel {
  margin-left: 18px;
}
.cancel-button {
  cursor: pointer;
  outline: none;
  background: #ffffff;
  border: 1px solid rgba(155, 155, 155, 0.2);
  border-radius: 2px;
  width: 110px;
  height: 31px;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #616262;
}
.buttons {
  display: flex;
  margin: 16px 10px 16px auto;
  width: fit-content;
}
#endtest-button {
  margin: auto 16px;
  background: #f66957;
  border-radius: 2px;
  width: fit-content;
  height: 30px;
  color: white;
  padding-right: 8px;
}
.end-test-text {
  cursor: pointer;
  font-family: Roboto-Bold;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  height: 30px;
}

.end-test-text span {
  margin-left: 10px;
}
.hr {
  margin-top: 24px;
  border: 0.5px solid #d9d9d9;
}
.hr-footer {
  margin-top: 32px;
  border: 1px solid #d9d9d9;
}
.duration-left {
  font-family: Roboto-Medium;
  font-size: 18px;
  color: #f66957;
  text-align: center;
  margin: 0px 8px 0px 10px;
}
.span-message {
  font-family: Roboto-Medium;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
}
.time-left {
  margin: 16px 24px auto 30px;
}
.time-left-box {
  background: #efeef3;
  border-radius: 2px;
  padding: 10px;
  margin-top: 10px;
  font-family: Roboto-Regular;
  font-size: 12px;
  color: #000000;
  align-items: center;
  display: flex;
  width: fit-content;
}
.close-icon {
  float: right;
  margin-top: -13px;
  margin-right: -8px;
}
.confirm-message {
  margin: 30px 30px 24px 30px;
  font-family: Roboto-Light;
  font-size: 24px;
  color: #616262;
  letter-spacing: 0;
  text-align: left;
}
.horizontal-line {
  border: 0.5px solid #d9d9d9;
}
.image {
  margin: 24px 76px;
}
.system-compatibilty {
  display: flex;
  padding: 25px 65px;
  background: rgba(246, 105, 87, 0.1);
}
.cross-symbol {
  margin-right: 16px;
  text-align: left;
}
.system-compatibilty-msg {
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
}
.browser-property-div {
  display: flex;
  margin: 24px auto 24px 30px;
}
.browser-property {
  font-family: Roboto-Medium;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  width: 112px;
  text-align: left;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  width: fit-content;
  margin: auto;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
